const WORKER_URL = 'https://icy-mode-bcd6.kiwanisfs.workers.dev/';
const MAX_WISHLIST_ITEMS = 100;
const HANDLE_CACHE_KEY = 'wl_handles';

function getHandleCache() {
  try { return JSON.parse(localStorage.getItem(HANDLE_CACHE_KEY) || '{}'); } catch { return {}; }
}

function saveHandleCache(cache) {
  try { localStorage.setItem(HANDLE_CACHE_KEY, JSON.stringify(cache)); } catch {}
}

function cacheHandles() {
  const cache = getHandleCache();
  document.querySelectorAll('[data-variant-id][data-product-handle]').forEach(btn => {
    const variantId = btn.getAttribute('data-variant-id');
    const handle = btn.getAttribute('data-product-handle');
    if (variantId && handle) cache[variantId] = handle;
  });
  // Also cache from current wishlist
  (window.customerWishlist || []).forEach(item => {
    if (item.vid && item.handle) cache[item.vid] = item.handle;
  });
  saveHandleCache(cache);
}

// Normalize wishlist — always returns array of {vid, handle} objects
function normalizeWishlist(raw) {
  if (!Array.isArray(raw)) return [];
  const cache = getHandleCache();
  return raw.map(item => {
    if (typeof item === 'string') {
      return { vid: item, handle: cache[item] || '' };
    }
    return { vid: String(item.vid), handle: item.handle || cache[item.vid] || '' };
  });
}

function getVariantIds() {
  return (window.customerWishlist || []).map(i => String(i.vid));
}

function syncHearts() {
  const ids = getVariantIds();
  document.querySelectorAll('[data-variant-id]').forEach(btn => {
    const id = String(btn.getAttribute('data-variant-id'));
    const svg = btn.querySelector('svg');
    if (ids.includes(id)) {
      btn.classList.add('wl-active');
      if (svg) svg.setAttribute('fill', '#e22120');
    } else {
      btn.classList.remove('wl-active');
      if (svg) svg.setAttribute('fill', 'none');
    }
  });
}

async function loadWishlist() {
  const customerId = window.shopifyCustomerId || "";
  if (!customerId) return;

  // Normalize Liquid-loaded data (may be old flat format or new object format)
  const liquidData = window.__liquidWishlist || [];
  window.customerWishlist = normalizeWishlist(liquidData);

  syncHearts();
  cacheHandles();

  if (document.getElementById('wishlist-grid')) {
    renderWishlistGrid();
  }

  // Background sync with Cloudflare
  try {
    const response = await fetch(`${WORKER_URL}?customerId=${customerId}`);
    const fresh = await response.json();
    if (Array.isArray(fresh) && fresh.length > 0) {
      window.customerWishlist = normalizeWishlist(fresh);
      syncHearts();
      cacheHandles();

      // Auto-migrate: if any items missing handles, save them back with handles
      const needsMigration = window.customerWishlist.some(i => !i.handle);
      if (needsMigration) {
        await migrateWishlist(customerId);
      }

      if (document.getElementById('wishlist-grid')) renderWishlistGrid();
    }
  } catch (error) {
    console.warn("Wishlist background sync failed:", error);
  }
}

// Migrate old variant-ID-only wishlist to new {vid, handle} format
async function migrateWishlist(customerId) {
  const cache = getHandleCache();
  const migrated = window.customerWishlist.map(item => ({
    vid: item.vid,
    handle: item.handle || cache[item.vid] || ''
  }));

  // Only migrate if we actually have handles to add
  if (migrated.some(i => i.handle)) {
    window.customerWishlist = migrated;
    try {
      await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerId, action: 'migrate', items: migrated }),
      });
    } catch (e) { console.warn('Migration failed:', e); }
  }
}

async function renderWishlistGrid() {
  const grid = document.getElementById('wishlist-grid');
  if (!grid) return;
  const wishlist = window.customerWishlist || [];

  const countEl = document.getElementById('wl-count-display');
  if (countEl) countEl.textContent = wishlist.length ? `${wishlist.length} item${wishlist.length !== 1 ? 's' : ''}` : '';

  if (wishlist.length === 0) {
    grid.innerHTML = `<div style="grid-column:1/-1;text-align:center;padding:60px 20px;">
      <p style="font-size:16px;margin-bottom:20px;">Your favourites list is empty.</p>
      <a href="/collections/all" class="btn btn--primary">Browse Products</a>
    </div>`;
    return;
  }

  const handles = [...new Set(wishlist.map(i => i.handle).filter(Boolean))];

  if (handles.length === 0) {
    grid.innerHTML = `<div style="grid-column:1/-1;text-align:center;padding:60px 20px;">
      <p style="margin-bottom:20px;">Please <a href="/collections/all" style="text-decoration:underline;">browse your collections</a> first to load your favourites.</p>
    </div>`;
    return;
  }

  grid.innerHTML = `<div style="grid-column:1/-1;text-align:center;padding:40px;color:#888;">Loading your items...</div>`;

  try {
    const results = await Promise.all(
      handles.map(handle =>
        fetch(`/products/${handle}.js`)
          .then(r => r.ok ? r.json() : null)
          .catch(() => null)
      )
    );

    const valid = results.filter(Boolean);

    if (valid.length === 0) {
      // B2B restriction — show static cards with just titles and handles
      grid.innerHTML = wishlist.filter(i => i.handle).map(item => `
        <div style="border:1px solid #e5e5e5;border-radius:8px;background:#fff;display:flex;flex-direction:column;overflow:hidden;">
          <a href="/products/${item.handle}" style="display:block;background:#f5f5f5;aspect-ratio:1;"></a>
          <div style="padding:14px;display:flex;flex-direction:column;flex:1;">
            <p style="font-size:14px;font-weight:600;margin:0 0 14px;">
              <a href="/products/${item.handle}" style="color:inherit;text-decoration:none;">${item.handle.replace(/-/g,' ')}</a>
            </p>
            <div style="margin-top:auto;">
              <a href="/products/${item.handle}" class="btn btn--primary" style="display:block;text-align:center;text-decoration:none;margin-bottom:8px;">View Product</a>
              <button onclick="toggleWishlist('${item.vid}')" style="display:block;width:100%;background:none;border:1px solid #ddd;border-radius:4px;color:#666;cursor:pointer;font-size:12px;padding:8px;">Remove</button>
            </div>
          </div>
        </div>`).join('');
      return;
    }

    const variantIds = getVariantIds();

    grid.innerHTML = valid.map(product => {
      const wishItem = wishlist.find(i => i.handle === product.handle);
      const variant = product.variants.find(v => variantIds.includes(String(v.id))) || product.variants[0];
      const image = formatImage(variant.featured_image?.src || product.featured_image?.src || product.images?.[0]?.src || '');
      const price = (parseInt(variant.price) / 100).toFixed(2);
      const available = variant.available;
      const showVariant = variant.title && variant.title !== 'Default Title';

      return `
        <div style="border:1px solid #e5e5e5;border-radius:8px;background:#fff;display:flex;flex-direction:column;overflow:hidden;">
          <a href="/products/${product.handle}?variant=${variant.id}" style="display:block;background:#f9f9f9;aspect-ratio:1;overflow:hidden;">
            ${image
              ? `<img src="${image}" alt="${product.title}" style="width:100%;height:100%;object-fit:contain;" loading="lazy">`
              : `<div style="width:100%;height:100%;background:#f0f0f0;"></div>`
            }
          </a>
          <div style="padding:14px;display:flex;flex-direction:column;flex:1;">
            <p style="font-size:14px;font-weight:600;margin:0 0 4px;line-height:1.3;">
              <a href="/products/${product.handle}?variant=${variant.id}" style="color:inherit;text-decoration:none;">${product.title}</a>
            </p>
            ${showVariant ? `<p style="font-size:12px;color:#888;margin:0 0 6px;">${variant.title}</p>` : ''}
            <p style="font-size:14px;font-weight:700;margin:0 0 14px;">$${price}</p>
            <div style="margin-top:auto;">
              ${available
                ? `<div id="wl-atc-wrap-${variant.id}">
                    <button onclick="wlAddToCart('${variant.id}', this)" style="display:block;width:100%;padding:10px;background:#1a1a1a;color:#fff;border:none;border-radius:4px;font-size:13px;font-weight:600;cursor:pointer;margin-bottom:8px;">Add to Cart</button>
                  </div>`
                : `<button disabled style="display:block;width:100%;padding:10px;background:#eee;color:#999;border:none;border-radius:4px;font-size:13px;margin-bottom:8px;">Out of Stock</button>`
              }
              <button onclick="toggleWishlist('${variant.id}')" style="display:block;width:100%;background:none;border:1px solid #ddd;border-radius:4px;color:#666;cursor:pointer;font-size:12px;padding:8px;">Remove</button>
            </div>
          </div>
        </div>`;
    }).join('');

  } catch (err) {
    console.error(err);
    grid.innerHTML = '<p style="grid-column:1/-1;text-align:center;">Error displaying list.</p>';
  }
}

function formatImage(src) {
  if (!src) return '';
  const base = src.startsWith('//') ? 'https:' + src : src;
  return base.split('?')[0] + '?width=400';
}

async function wlAddToCart(variantId, btn) {
  const wrap = document.getElementById(`wl-atc-wrap-${variantId}`);
  if (!wrap) return;
  btn.disabled = true;
  btn.textContent = 'Adding...';

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    // Store cart item key for fast qty updates
    const cartData = await fetch('/cart.js').then(r => r.json());
    const item = cartData.items.find(i => String(i.variant_id) === String(variantId));
    const cartKey = item?.key || '';

    wrap.innerHTML = `
      <div style="display:flex;align-items:center;border:1px solid #ddd;border-radius:4px;overflow:hidden;height:40px;margin-bottom:8px;">
        <button onclick="wlChangeQty('${variantId}','${cartKey}',-1,this)" style="width:40px;height:40px;border:none;border-right:1px solid #ddd;background:#f5f5f5;font-size:20px;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;">−</button>
        <span id="wl-qty-${variantId}" style="flex:1;text-align:center;font-weight:600;font-size:14px;">1</span>
        <button onclick="wlChangeQty('${variantId}','${cartKey}',1,this)" style="width:40px;height:40px;border:none;border-left:1px solid #ddd;background:#f5f5f5;font-size:20px;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;">+</button>
      </div>`;
  } catch (err) {
    console.error(err);
    btn.disabled = false;
    btn.textContent = 'Add to Cart';
    alert('Failed to add to cart.');
  }
}

async function wlChangeQty(variantId, cartKey, delta, btn) {
  const qtyEl = document.getElementById(`wl-qty-${variantId}`);
  const wrap = document.getElementById(`wl-atc-wrap-${variantId}`);
  if (!qtyEl || !wrap) return;

  const current = parseInt(qtyEl.textContent) || 1;
  const newQty = current + delta;
  btn.disabled = true;

  try {
    if (newQty <= 0) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: cartKey, quantity: 0 }),
      });
      wrap.innerHTML = `<button onclick="wlAddToCart('${variantId}', this)" style="display:block;width:100%;padding:10px;background:#1a1a1a;color:#fff;border:none;border-radius:4px;font-size:13px;font-weight:600;cursor:pointer;margin-bottom:8px;">Add to Cart</button>`;
    } else {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: cartKey, quantity: newQty }),
      });
      qtyEl.textContent = newQty;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  } catch (err) {
    console.error(err);
  } finally {
    btn.disabled = false;
  }
}

async function toggleWishlist(variantId) {
  const customerId = window.shopifyCustomerId;
  if (!customerId) return alert("Please log in to save favourites.");

  let list = window.customerWishlist || [];
  const vIdStr = String(variantId);
  const isAdding = !list.find(i => String(i.vid) === vIdStr);

  if (isAdding && list.length >= MAX_WISHLIST_ITEMS) {
    alert(`Your Favourites list is full (${MAX_WISHLIST_ITEMS} items). Please remove an item before adding a new one.`);
    return;
  }

  const cache = getHandleCache();
  const handle = cache[vIdStr] || document.querySelector(`[data-variant-id="${vIdStr}"]`)?.getAttribute('data-product-handle') || '';

  if (isAdding) {
    list.push({ vid: vIdStr, handle });
  } else {
    list = list.filter(i => String(i.vid) !== vIdStr);
  }

  window.customerWishlist = list;
  syncHearts();
  cacheHandles();
  if (document.getElementById('wishlist-grid')) renderWishlistGrid();

  try {
    await fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId, variantId: vIdStr, handle, action: isAdding ? 'add' : 'remove' })
    });
  } catch (e) { console.error(e); }
}

window.syncHearts = syncHearts;
window.toggleWishlist = toggleWishlist;
window.wlAddToCart = wlAddToCart;
window.wlChangeQty = wlChangeQty;

document.addEventListener('DOMContentLoaded', loadWishlist);
window.addEventListener('load', syncHearts);
